// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3DzqilsE_-MUPpWlA4vZi8","videoTitle":"_3RfvoTlNn0Y1DPstXBx6GU","videoWrapper":"X4m4-pdwpCb-oEU8fDig0"};